import LdfView from "@features/creation/ldf/components/LdfView";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { Eye } from "lucide-react";

export const Route = createFileRoute("/_app/creation/ldf/$id/view")({
  loader: requirePermission(PERMISSIONS.CREATION.LDF.VIEW),
  staticData: {
    title: "Détails LDF",
    icon: Eye,
    permission: PERMISSIONS.CREATION.LDF.VIEW,
    section: "Creation",
    showInBreadcrumb: true,
  },
  component: ViewLdfPage,
});

function ViewLdfPage() {
  return <LdfView />;
}
